import React from 'react'
import { useAppDispatch, useAppSelector } from '../redux'

import { FlowType } from '@SonarCX/slices/customFields/flows/helpers'

import { selectFlows, fetchFlow } from '@SonarCX/slices/customFields/flows'

const useCustomFieldFlows = (flowType: FlowType) => {
  const dispatch = useAppDispatch()

  const { flows, loaded, loading } = useAppSelector(selectFlows)

  // All flows of the specified type
  const allFlows = React.useMemo(() => flows[flowType] ?? [], [flows, flowType])

  const filteredFlows = React.useMemo(() => {
    return allFlows.slice()
  }, [allFlows])

  // Check if the current flow has fields to show
  const hasFields = React.useMemo(() => {
    const count = filteredFlows.reduce(
      (acc, curr) => acc + curr.fields.length,
      0
    )

    return count > 0
  }, [filteredFlows])

  // Load flow if needed
  React.useEffect(() => {
    if (!loaded[flowType] && !loading[flowType]) {
      dispatch(fetchFlow(flowType))
    }
  }, [loaded, loading, flowType, dispatch])

  return { allFlows, flows: filteredFlows, hasFields }
}

export default useCustomFieldFlows
